<template>
  <div>
    <div class="mesgboxtop">
      <div class="flex-centerCloumn paddingtb1">
        <!-- <van-uploader
          v-model="fileList"
          multiple
          :after-read="onFileRead"
          :max-count="1"
        /> -->
        <img class="mesgimg" :src="storeMesg.thumb_url" />
        <div class="textfont maincolor">{{ storeMesg.name }}</div>
        <!-- <div class="textfont maincolor">
          <input
            class="inputbox1"
            type="text"
            v-model="name"
            placeholder="请输入店铺名"
          />
        </div> -->
      </div>
      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">店铺状态</div>
        </div>
        <div class="flexbetween paddingtb1 borderbottom">
          <div class="textfont tipcolor1">营业时段</div>
          <div class="textfont">单时段营业</div>
        </div>
        <div class="flexbetween paddingtb1 borderbottom">
          <div class="textfont tipcolor1">营业时间</div>
          <input
            class="inputbox"
            type="text"
            v-model="business_time"
            placeholder="营业时间 例：08：00-18：00"
          />
          <!-- <div class="textfont">{{ storeMesg.business_time[0] }}</div> -->
        </div>
        <div class="flexbetween paddingtb1">
          <div class="textfont tipcolor1">休息时间</div>
          <div class="restTime">
            <div class="textfont marginright" @click="openRestS">
              {{ rest_s_time ? rest_s_time : "选择开始休息时间" }}
            </div>
            <div class="textfont marginright">至</div>
            <div class="textfont" @click="openRestE">
              {{ rest_e_time ? rest_e_time : "选择结束休息时间" }}
            </div>
          </div>
        </div>
        <van-popup
          v-model="showRestS"
          position="bottom"
          :style="{ height: '50%' }"
        >
          <van-datetime-picker
            v-model="current_s_time"
            type="datetime"
            title="选择开始休息时间"
            :min-date="StartminDate"
            :max-date="StartmaxDate"
            @confirm="firmSTime"
            @cancel="closeRestS"
          />
        </van-popup>
        <van-popup
          v-model="showRestE"
          position="bottom"
          :style="{ height: '50%' }"
        >
          <van-datetime-picker
            v-model="current_e_time"
            type="datetime"
            title="选择结束休息时间"
            :min-date="EndminDate"
            :max-date="EndmaxDate"
            @confirm="firmETime"
            @cancel="closeRestE"
          />
        </van-popup>
      </div>
      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">店铺地址</div>
        </div>
        <div class="flexbetween paddingtb1 borderbottom">
          <div class="textfont tipcolor1">省市</div>
          <!-- @click="openAddress" -->
          <div class="textfont">
            {{ storeMesg.province }}{{ storeMesg.city }}
          </div>
        </div>
        <!-- <van-popup
          v-model="showAddress"
          position="bottom"
          :style="{ height: '50%' }"
        >
          <van-area
            title="选择省市"
            @confirm="firmAddress"
            :area-list="areaList"
            :columns-num="2"
          />
        </van-popup> -->
        <div class="flexbetween paddingtb1">
          <div class="textfont tipcolor1">具体地址</div>
          <!-- <input
            class="inputbox"
            type="text"
            v-model="address"
            placeholder="请输入详细地址"
          /> -->
          <div class="textfont">{{ storeMesg.address }}</div>
        </div>
      </div>
      <div class="packageDesc_shangpinmesg">
        <div class="beCareful-titlebox">
          <div class="beCareful-icon"></div>
          <div class="beCareful-title">联系电话</div>
        </div>
        <div class="flexbetween paddingtb1">
          <div class="textfont tipcolor1">电话号码</div>
          <input
            class="inputbox"
            type="text"
            v-model="store_tel"
            placeholder="请输入联系号码"
          />
          <!-- <div class="textfont">{{ storeMesg.store_tel }}</div> -->
        </div>
        <div class="flexbetween paddingtb1">
          <div class="textfont tipcolor1">联系人</div>
          <input
            class="inputbox"
            type="text"
            v-model="store_manager"
            placeholder="请输入联系人姓名"
          />
          <!-- <div class="textfont">{{ storeMesg.store_tel }}</div> -->
        </div>
      </div>
      <div class="addbotton" @click="confirm">确认修改</div>
    </div>
  </div>
</template>

<script>
import httper from "../../../api/http";
import { areaList } from "@vant/area-data";
export default {
  data() {
    return {
      storeMesg: {},
      name: "", //店铺名
      fileList: [], //缩略图
      store_tel: "", //联系电话
      store_manager: "", //联系人
      business_time: "", //营业时间
      showRestS: false, //休息开始时间弹框
      showRestE: false, //休息结束时间弹框
      StartminDate: new Date(2020, 0, 1),
      StartmaxDate: new Date(2100, 12, 31),
      current_s_time: new Date(),
      rest_s_date: "",
      rest_e_date: "",
      rest_s_time: "",
      EndminDate: new Date(2020, 0, 1),
      EndmaxDate: new Date(2100, 12, 31),
      current_e_time: new Date(),
      rest_e_time: "",
      areaList,
      showAddress: false,
      province: "", //省
      city: "", //市
      address: "" //详细地址
    };
  },
  created() {
    this.request("storeIndex");
  },
  mounted() {},
  methods: {
    // 上传缩略图
    onFileRead(file) {
      // 这里可以处理文件上传
      const formData = new FormData();
      formData.append("file", file.file);
      console.log("file", file);
      // this.request("upload", formData);
    },
    // 开始休息时间弹框
    openRestS() {
      this.showRestS = true;
    },
    closeRestS() {
      this.showRestS = false;
    },
    firmSTime(e, isStamp = false) {
      let date = "";
      if (isStamp) {
        date = new Date(e);
        this.rest_s_date = e;
      } else {
        date = e;
        this.rest_s_date = e.getTime();
      }

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let dte = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      this.rest_s_time = `${year}-${month}-${dte} ${hours}:${minutes}`;
      this.current_s_time = date;

      console.log("this.rest_s_time", this.rest_s_time);
      this.showRestS = false;
    },

    openRestE() {
      this.showRestE = true;
    },
    closeRestE() {
      this.showRestE = false;
    },
    firmETime(e, isStamp = false) {
      let date = "";
      if (isStamp) {
        date = new Date(e);
        this.rest_e_date = e;
      } else {
        date = e;
        this.rest_e_date = e.getTime();
      }

      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let dte = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      this.rest_e_time = `${year}-${month}-${dte} ${hours}:${minutes}`;
      this.current_e_time = date;

      this.showRestE = false;
    },
    // 省市弹框
    openAddress() {
      this.showAddress = true;
    },
    closeAddress() {
      this.showAddress = false;
    },
    // 省市选择
    firmAddress(e) {
      this.province = e[0].name;
      this.city = e[1].name;
      this.showAddress = false;
    },
    // edit
    confirm() {
      let requestData = {
        business_time: this.business_time,
        store_tel: this.store_tel,
        store_manager: this.store_manager
      };
      if (this.rest_s_date) {
        requestData.rest_s_time = this.rest_s_date;
      }
      if (this.rest_e_date) {
        requestData.rest_e_time = this.rest_e_date;
      }
      this.request("editstore", requestData);
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        //店铺信息
        case "storeIndex":
          httper.get(
            "/store/index",
            requestData,
            function(res) {
              if (res.code === 0) {
                that.storeMesg = res.data;
                that.name = that.storeMesg.name;
                that.fileList.push({ url: that.storeMesg.thumb_url });
                that.store_tel = that.storeMesg.store_tel;
                that.store_manager = that.storeMesg.store_manager;
                that.province = that.storeMesg.province;
                that.city = that.storeMesg.city;
                that.address = that.storeMesg.address;
                that.business_time = that.storeMesg.business_time[0];
                that.firmSTime(that.storeMesg.rest_s_time, true);
                that.firmETime(that.storeMesg.rest_e_time, true);
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
        //上传图片
        case "upload":
          httper.post(
            "media/upload-wechat",
            requestData,
            function(res) {
              if (res.code == 0) {
                console.log("res", res);
                // that.fileList.push({ url: that.storeMesg.thumb_url });
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
        //编辑店铺
        case "editstore":
          httper.post(
            "store/edit",
            requestData,
            function(res) {
              if (res.code == 0) {
                that.$toast({
                  message: "修改成功"
                });
                that.$router.push({
                  path: "/mine"
                });
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
      }
    }
  }
};
</script>

<style>
.mesgboxtop {
  width: calc(100% - 20px);
  margin: 10px;
  border-radius: 8px;
  background-color: #ffffff;
  padding: 0 10px;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.packageDesc_shangpinmesg {
  width: 100%;
  /* padding: 10px;
  box-sizing: border-box; */

  /*    margin-bottom: 20px; */
}
.restTime {
  display: flex;
  align-items: center;
}

.mesgimg {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
  border-radius: 25px;
}

.verifyImgtop {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #f2f2f2;
  /*    background: linear-gradient(160deg, #1496f1, #E0F0FA); */
}

.verifyimg {
  width: 80px;
  height: 80px;
  margin-bottom: 12px;
}
.inputbox {
  text-align: end;
}
.inputbox1 {
  text-align: center;
}
.confirmbtn {
}
</style>



// WEBPACK FOOTER //
// src/pages/store/storeMesg.vue